import { useQuery, useQueryClient } from 'react-query';
import { apiService } from '~services/ApiService';
import { useUserStore } from '~providers/userStore/zustand';

export const useUnreadNotificationsCount = () => {
  const user = useUserStore(state => state.user);
  const queryClient = useQueryClient();
  
  return useQuery<number, Error>(
    'unreadNotificationsCount',
    async () => {
      // Get all notifications and count unread ones
      const notifications = await apiService.get<any[]>('notifications/all');
      return notifications.filter(n => n.status.toLowerCase() === 'unread').length;
    },
    {
      enabled: !!user && !!queryClient, // Only run when user is available and QueryClient is set
      staleTime: 10000, // 10 seconds
      refetchInterval: 30000, // Refetch every 30 seconds for real-time updates
      refetchOnWindowFocus: true,
      refetchOnMount: true,
    }
  );
};